import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { toolsController } from "../../controllers/tools.controller";
import { dateConvert } from "../common/Helpers";
import LoadingPanel from "../common/LoadingPanel";
import DialogWindow from "../common/DialogWindow";
import { registerForLocalization, provideLocalizationService } from "@progress/kendo-react-intl";
import { Localization } from "../common/Localization";
import { Button } from "@progress/kendo-react-buttons";
import KontrolaProdejnyDialogContent from "./Tools/KontrolaProdejnyDialogContent";
import confirmService from "../common/confirmService";
import { authenticationService } from "../../services/authentication.service";
import KontrolaSpravyDialogContent from "./Tools/KontrolaSpravyDialogContent";
import NahlasenieNegenerovaneSpravyDialogContent from "./Tools/NahlasenieNegenerovaneSpravyDialogContent";
import TextNegenerovaneSpravyDialogContent from "./Tools/TextNegenerovaneSpravyDialogContent";
import ExpediciaNegenerovaneSpravyDialogContent from "./Tools/ExpediciaNegenerovaneSpravyDialogContent";
import AvizoNegenerovaneSpravyDialogContent from "./Tools/AvizoNegenerovaneSpravyDialogContent";
import VytvorenieUzivatelovDialogContent from "./Tools/VytvorenieUzivatelovDialogContent";
import ZoznamUzivatelovDialogContent from "./Tools/ZoznamUzivatelovDialogContent";
import ZoznamExpedovaneBalikyParcelDialogContent from "./Tools/ZoznamExpedovaneBalikyParcelDialogContent";

class Tools extends Component {
    state = {
        loading: true,
        loadingBalikArtikleSave: false,
        loadingGetArtikelByCiarovyKod: false,
        loadingPrijemBalikaUlozit: false,
        loadingPrijemBalikaPridatKus: false,
        disableButtons: false,
        informacie: null
    };

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.refreshPanel();
    }

    openKontrolaProdejnyDialog = () => {
        var localizationService = provideLocalizationService(this);

        this.setState({
            dialog: {
                title: localizationService.toLanguageString("ToolsPage.Kontrola nastavenia predajne", "Kontrola nastavenia predajne"),
                content: () => <KontrolaProdejnyDialogContent />,
                height: "70%",
                width: "600px"
            }
        });
    };

    opravaNastaveniaHandleClick = () => {
        this.setState({ disableButtons: true });

        toolsController.opravaNastaveniaPredajne().then(async (response) => {
            if (response.errorMessage) {
                await confirmService.show({
                    type: response.messageType,
                    message: response.errorMessage,
                    logMessage: true
                });
            }

            this.setState({ disableButtons: false });
        });
    };

    vytvoritSpravuAvizoHandleClick = () => {
        this.setState({ disableButtons: true });

        toolsController.vytvorenieSpravyAvizo().then(async (response) => {
            if (response.errorMessage) {
                await confirmService.show({
                    type: response.messageType,
                    message: response.errorMessage,
                    logMessage: true
                });
            }

            this.setState({ disableButtons: false });
        });
    };

    openKontrolaSpravyDialog = () => {
        var localizationService = provideLocalizationService(this);

        this.setState({
            dialog: {
                title: localizationService.toLanguageString("ToolsPage.Kontrola generování správ", "Kontrola generování správ"),
                content: () => <KontrolaSpravyDialogContent />,
                height: "70%",
                width: "600px"
            }
        });
    };

    openNahlasenieNegenerovaneSpravyDialog = () => {
        var localizationService = provideLocalizationService(this);

        this.setState({
            dialog: {
                title: localizationService.toLanguageString("ToolsPage.Nevygenerované správy Nahlásenie", "Nevygenerované správy Nahlásenie"),
                content: () => <NahlasenieNegenerovaneSpravyDialogContent />,
                height: "90%",
                width: "90%"
            }
        });
    };

    openTextNegenerovaneSpravyDialog = () => {
        var localizationService = provideLocalizationService(this);

        this.setState({
            dialog: {
                title: localizationService.toLanguageString("ToolsPage.Nevygenerované správy Text", "Nevygenerované správy Text"),
                content: () => <TextNegenerovaneSpravyDialogContent />,
                height: "90%",
                width: "90%"
            }
        });
    };

    openExpediciaNegenerovaneSpravyDialog = () => {
        var localizationService = provideLocalizationService(this);

        this.setState({
            dialog: {
                title: localizationService.toLanguageString("ToolsPage.Nevygenerované správy Expedicia", "Nevygenerované správy Expedicia"),
                content: () => <ExpediciaNegenerovaneSpravyDialogContent />,
                height: "90%",
                width: "90%"
            }
        });
    };

    openAvizoNegenerovaneSpravyDialog = () => {
        var localizationService = provideLocalizationService(this);

        this.setState({
            dialog: {
                title: localizationService.toLanguageString("ToolsPage.Nevygenerované správy Avizo", "Nevygenerované správy Avizo"),
                content: () => <AvizoNegenerovaneSpravyDialogContent />,
                height: "90%",
                width: "90%"
            }
        });
    };

    openVytvorenieUzivatelovDialog = () => {
        var localizationService = provideLocalizationService(this);

        this.setState({
            dialog: {
                title: localizationService.toLanguageString("ToolsPage.Vytvorenie užívateľov", "Vytvorenie užívateľov"),
                content: (onClose) => <VytvorenieUzivatelovDialogContent toggleDialog={onClose} />,
                height: "270px",
                width: "400px"
            }
        });
    };

    openZoznamUzivatelovDialog = () => {
        var localizationService = provideLocalizationService(this);

        this.setState({
            dialog: {
                title: localizationService.toLanguageString("ToolsPage.Zoznam administrátorov", "Zoznam administrátorov"),
                content: (onClose) => <ZoznamUzivatelovDialogContent toggleDialog={onClose} />,
                height: "600px",
                width: "600px"
            }
        });
    };

    openZoznamVygenerovaneStitkyDialog = () => {
        var localizationService = provideLocalizationService(this);

        this.setState({
            dialog: {
                title: localizationService.toLanguageString("ToolsPage.Vygenerované štítky a čísla dopravcov", "Vygenerované štítky a čísla dopravcov"),
                content: (onClose) => <ZoznamExpedovaneBalikyParcelDialogContent toggleDialog={onClose} />,
                height: "90%",
                width: "90%"
            }
        });
    };

    refreshPanel = () => {
        this.setState({
            loading: true,
            loadingBalikArtikleSave: true,
            loadingGetArtikelByCiarovyKod: true,
            loadingPrijemBalikaUlozit: true,
            loadingPrijemBalikaPridatKus: true
        });

        toolsController.getInformacie().then(async (response) => {
            this.setState({
                loading: false,
                informacie: response
            });

            if (response.errorMessage) {
                await confirmService.show({
                    type: response.messageType,
                    message: response.errorMessage,
                    logMessage: true
                });
            }
        });

        toolsController.getAkceTrvani("BalikArtikleController.Save", "Gate.DodavkyTovaru.Web.Controllers.BalikArtikleController").then(async (response) => {
            this.setState({
                loadingBalikArtikleSave: false,
                balikArtikleSave: response
            });

            if (response.errorMessage) {
                await confirmService.show({
                    type: response.messageType,
                    message: response.errorMessage,
                    logMessage: true
                });
            }
        });

        toolsController
            .getAkceTrvani("BalikArtikleController.GetArtikelByCiarovyKod", "Gate.DodavkyTovaru.Web.Controllers.BalikArtikleController")
            .then(async (response) => {
                this.setState({
                    loadingGetArtikelByCiarovyKod: false,
                    getArtikelByCiarovyKod: response
                });

                if (response.errorMessage) {
                    await confirmService.show({
                        type: response.messageType,
                        message: response.errorMessage,
                        logMessage: true
                    });
                }
            });

        toolsController
            .getAkceTrvani("PrijemBalikaController.UlozitBalik", "Gate.DodavkyTovaru.Web.Controllers.PrijemBalikaController")
            .then(async (response) => {
                this.setState({
                    loadingPrijemBalikaUlozit: false,
                    prijemBalikaUlozit: response
                });

                if (response.errorMessage) {
                    await confirmService.show({
                        type: response.messageType,
                        message: response.errorMessage,
                        logMessage: true
                    });
                }
            });

        toolsController
            .getAkceTrvani("PrijemBalikaController.PridatKus", "Gate.DodavkyTovaru.Web.Controllers.PrijemBalikaController")
            .then(async (response) => {
                this.setState({
                    loadingPrijemBalikaPridatKus: false,
                    prijemBalikaPridatKus: response
                });

                if (response.errorMessage) {
                    await confirmService.show({
                        type: response.messageType,
                        message: response.errorMessage,
                        logMessage: true
                    });
                }
            });
    };

    render() {
        let contents = (
            <div>
                <h2 className="row">
                    <div className="col-xs-6">
                        <Localization messageKey={"MenuFRM.NÁSTROJE"} defaultMessage={"NÁSTROJE"} />
                    </div>
                    <div className="col-xs-6">
                        <Button icon="refresh" className="pull-right" onClick={() => this.refreshPanel()} disabled={this.state.loading}>
                            <Localization messageKey={"LogReport.Grid.Aktualizovať"} defaultMessage={"Aktualizovať"} />
                        </Button>
                    </div>
                </h2>
                <div className="row">
                    <div className="col-xs-6">
                        <fieldset className="tools-button-group">
                            <legend>
                                <Localization messageKey={"ToolsPage.Kontroly a nastavenia"} defaultMessage={"Kontroly a nastavenia"} />:
                            </legend>
                            <div className="row">
                                <div className="col-xs-12">
                                    <Button icon="check" onClick={() => this.openKontrolaProdejnyDialog()} disabled={this.state.disableButtons}>
                                        <Localization messageKey={"ToolsPage.Kontrola nastavenia predajne"} defaultMessage={"Kontrola nastavenia predajne"} />
                                    </Button>
                                    <Button icon="wrench" onClick={() => this.opravaNastaveniaHandleClick()} disabled={this.state.disableButtons}>
                                        <Localization messageKey={"ToolsPage.Oprava nastavenia predajne"} defaultMessage={"Oprava nastavenia predajne"} />
                                    </Button>
                                    <Button icon="wrench" onClick={() => this.vytvoritSpravuAvizoHandleClick()} disabled={this.state.disableButtons}>
                                        <Localization messageKey={"ToolsPage.Vytvorenie spravy Avizo"} defaultMessage={"Vytvorenie spravy Avizo"} />
                                    </Button>
                                </div>
                            </div>
                        </fieldset>
                        <fieldset className="tools-button-group m-t-sm">
                            <legend>
                                <Localization messageKey={"ToolsPage.Správy"} defaultMessage={"Správy"} />:
                            </legend>
                            <div className="row">
                                <div className="col-xs-12">
                                    <Button icon="check" onClick={() => this.openKontrolaSpravyDialog()} disabled={this.state.disableButtons}>
                                        <Localization messageKey={"ToolsPage.Kontrola správ"} defaultMessage={"Kontrola správ"} />
                                    </Button>
                                    <Button icon="grid-layout" onClick={() => this.openAvizoNegenerovaneSpravyDialog()} disabled={this.state.disableButtons}>
                                        <Localization messageKey={"ToolsPage.Nevygenerované správy Avizo"} defaultMessage={"Nevygenerované správy Avizo"} />
                                    </Button>
                                </div>
                            </div>
                            <div className="row m-t-sm">
                                <div className="col-xs-12">
                                    <Button
                                        icon="grid-layout"
                                        onClick={() => this.openExpediciaNegenerovaneSpravyDialog()}
                                        disabled={this.state.disableButtons}>
                                        <Localization
                                            messageKey={"ToolsPage.Nevygenerované správy Expedicia"}
                                            defaultMessage={"Nevygenerované správy Expedicia"}
                                        />
                                    </Button>
                                    <Button
                                        icon="grid-layout"
                                        onClick={() => this.openNahlasenieNegenerovaneSpravyDialog()}
                                        disabled={this.state.disableButtons}>
                                        <Localization
                                            messageKey={"ToolsPage.Nevygenerované správy Nahlásenie"}
                                            defaultMessage={"Nevygenerované správy Nahlásenie"}
                                        />
                                    </Button>
                                    <Button icon="grid-layout" onClick={() => this.openTextNegenerovaneSpravyDialog()} disabled={this.state.disableButtons}>
                                        <Localization messageKey={"ToolsPage.Nevygenerované správy Text"} defaultMessage={"Nevygenerované správy Text"} />
                                    </Button>
                                </div>
                            </div>
                        </fieldset>
                        <fieldset className="tools-button-group m-t-sm">
                            <legend>
                                <Localization messageKey={"ToolsPage.Užívatelia"} defaultMessage={"Užívatelia"} />:
                            </legend>
                            <div className="row">
                                <div className="col-xs-12">
                                    <Button icon="user" onClick={() => this.openVytvorenieUzivatelovDialog()} disabled={this.state.disableButtons}>
                                        <Localization messageKey={"ToolsPage.Vytvorenie užívateľov"} defaultMessage={"Vytvorenie užívateľov"} />
                                    </Button>
                                    <Button icon="user" onClick={() => this.openZoznamUzivatelovDialog()} disabled={this.state.disableButtons}>
                                        <Localization messageKey={"ToolsPage.Zoznam administrátorov"} defaultMessage={"Zoznam administrátorov"} />
                                    </Button>
                                </div>
                            </div>
                        </fieldset>
                        <fieldset className="tools-button-group m-t-sm">
                            <legend>
                                <Localization messageKey={"ToolsPage.Expedované balíky"} defaultMessage={"Expedované balíky"} />:
                            </legend>
                            <div className="row">
                                <div className="col-xs-12">
                                    <Button icon="user" onClick={() => this.openZoznamVygenerovaneStitkyDialog()} disabled={this.state.disableButtons}>
                                        <Localization messageKey={"ToolsPage.Vygenerované štítky"} defaultMessage={"Vygenerované štítky"} />
                                    </Button>
                                </div>
                            </div>{" "}
                        </fieldset>
                    </div>
                    <div className="col-xs-6">
                        <fieldset className="tools-button-group" id="ToolsInfoPanel">
                            {this.state.loading ? (
                                <LoadingPanel />
                            ) : (
                                <React.Fragment>
                                    <legend>
                                        <Localization messageKey={"ToolsPage.Informácie"} defaultMessage={"Informácie"} />:
                                    </legend>
                                    <div className="row">
                                        <div className="col-xs-6">Verzia aplikácie:</div>
                                        <div className="col-xs-6 font-bold">
                                            <span title="{this.state.informacie.lastInformationalVersion}">{this.state.informacie.lastVersion}</span>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-xs-6">Sklad / Predajňa:</div>
                                        <div className="col-xs-6 font-bold">
                                            {this.state.informacie.skladId} - {this.state.informacie.skladSkratka} ({this.state.informacie.skladNazov})
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-xs-6">Prihlásený užívateľ:</div>
                                        <div className="col-xs-6 font-bold">
                                            {this.state.informacie.uzivatelId} - {this.state.informacie.uzivatelMeno} ({this.state.informacie.uzivatelCeleMeno})
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-xs-6">Neodoslané správy (pre predajňu / všetky):</div>
                                        <div className="col-xs-6 font-bold">
                                            {this.state.informacie.neodeslaneSpravyPreSklad} / {this.state.informacie.neodeslaneSpravyVsechny} (
                                            {this.state.informacie.odeslaniChyba ? (
                                                <span className="color-red">{this.state.informacie.posledniDatumOdeslani}</span>
                                            ) : (
                                                <span className="color-green">{this.state.informacie.posledniDatumOdeslani}</span>
                                            )}
                                            )
                                        </div>
                                    </div>
                                </React.Fragment>
                            )}
                        </fieldset>
                        <fieldset className="tools-button-group m-t-sm" id="ToolsBalikArtikleSaveTrvaniPanel">
                            <legend>
                                <Localization messageKey={"ToolsPage.Výkon rutiny"} defaultMessage={"Výkon rutiny"} /> - BalikArtikleController.Save:
                            </legend>
                            {this.state.loadingBalikArtikleSave || !this.state.balikArtikleSave ? (
                                <LoadingPanel />
                            ) : (
                                <React.Fragment>
                                    <div className="row">
                                        <div className="col-xs-6">Počet spustení (dnes):</div>
                                        <div className="col-xs-6 font-bold">
                                            {this.state.balikArtikleSave.pocetDnes.toLocaleString("sk-SK", {
                                                maximumFractionDigits: 0
                                            })}
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-xs-6">Priemerná doba trvania (dnes):</div>
                                        <div className="col-xs-6 font-bold">
                                            {this.state.balikArtikleSave.trvaniPrumerDnes.toLocaleString("sk-SK", {
                                                style: "unit",
                                                unit: "millisecond",
                                                maximumFractionDigits: 0
                                            })}
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-xs-6">Maximálna doba trvania (dnes):</div>
                                        <div className="col-xs-6 font-bold">
                                            {this.state.balikArtikleSave.trvaniMaximumDnes.toLocaleString("sk-SK", {
                                                style: "unit",
                                                unit: "millisecond",
                                                maximumFractionDigits: 0
                                            })}
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-xs-6">Počet chyb (dnes):</div>
                                        <div className="col-xs-6 font-bold">
                                            {this.state.balikArtikleSave.chybyDnes ? (
                                                <span className="color-red">
                                                    {this.state.balikArtikleSave.chybyDnes.toLocaleString("sk-SK", {
                                                        maximumFractionDigits: 0
                                                    })}
                                                </span>
                                            ) : (
                                                <span className="color-green">
                                                    {this.state.balikArtikleSave.chybyDnes.toLocaleString("sk-SK", {
                                                        maximumFractionDigits: 0
                                                    })}
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                    <div className="row m-t-sm">
                                        <div className="col-xs-6">Počet spustení (týždeň):</div>
                                        <div className="col-xs-6 font-bold">
                                            {this.state.balikArtikleSave.pocetTyden.toLocaleString("sk-SK", {
                                                maximumFractionDigits: 0
                                            })}
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-xs-6">Priemerná doba trvania (týždeň):</div>
                                        <div className="col-xs-6 font-bold">
                                            {this.state.balikArtikleSave.trvaniPrumerTyden.toLocaleString("sk-SK", {
                                                style: "unit",
                                                unit: "millisecond",
                                                maximumFractionDigits: 0
                                            })}
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-xs-6">Maximálna doba trvania (týždeň):</div>
                                        <div className="col-xs-6 font-bold">
                                            {this.state.balikArtikleSave.trvaniMaximumTyden.toLocaleString("sk-SK", {
                                                style: "unit",
                                                unit: "millisecond",
                                                maximumFractionDigits: 0
                                            })}
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-xs-6">Počet chyb (týždeň):</div>
                                        <div className="col-xs-6 font-bold">
                                            {this.state.balikArtikleSave.chybyTyden ? (
                                                <span className="color-red">
                                                    {this.state.balikArtikleSave.chybyTyden.toLocaleString("sk-SK", {
                                                        maximumFractionDigits: 0
                                                    })}
                                                </span>
                                            ) : (
                                                <span className="color-green">
                                                    {this.state.balikArtikleSave.chybyTyden.toLocaleString("sk-SK", {
                                                        maximumFractionDigits: 0
                                                    })}
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                </React.Fragment>
                            )}
                        </fieldset>
                        <fieldset className="tools-button-group m-t-sm" id="ToolsBalikArtikleGetArtikelTrvaniPanel">
                            <legend>
                                <Localization messageKey={"ToolsPage.Výkon rutiny"} defaultMessage={"Výkon rutiny"} /> -
                                BalikArtikleController.GetArtikelByCiarovyKod:
                            </legend>
                            {this.state.loadingGetArtikelByCiarovyKod || !this.state.getArtikelByCiarovyKod ? (
                                <LoadingPanel />
                            ) : (
                                <React.Fragment>
                                    <div className="row">
                                        <div className="col-xs-6">Počet spustení (dnes):</div>
                                        <div className="col-xs-6 font-bold">
                                            {this.state.getArtikelByCiarovyKod.pocetDnes.toLocaleString("sk-SK", {
                                                maximumFractionDigits: 0
                                            })}
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-xs-6">Priemerná doba trvania (dnes):</div>
                                        <div className="col-xs-6 font-bold">
                                            {this.state.getArtikelByCiarovyKod.trvaniPrumerDnes.toLocaleString("sk-SK", {
                                                style: "unit",
                                                unit: "millisecond",
                                                maximumFractionDigits: 0
                                            })}
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-xs-6">Maximálna doba trvania (dnes):</div>
                                        <div className="col-xs-6 font-bold">
                                            {this.state.getArtikelByCiarovyKod.trvaniMaximumDnes.toLocaleString("sk-SK", {
                                                style: "unit",
                                                unit: "millisecond",
                                                maximumFractionDigits: 0
                                            })}
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-xs-6">Počet chyb (dnes):</div>
                                        <div className="col-xs-6 font-bold">
                                            {this.state.getArtikelByCiarovyKod.chybyDnes ? (
                                                <span className="color-red">
                                                    {this.state.getArtikelByCiarovyKod.chybyDnes.toLocaleString("sk-SK", {
                                                        maximumFractionDigits: 0
                                                    })}
                                                </span>
                                            ) : (
                                                <span className="color-green">
                                                    {this.state.getArtikelByCiarovyKod.chybyDnes.toLocaleString("sk-SK", {
                                                        maximumFractionDigits: 0
                                                    })}
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                    <div className="row m-t-sm">
                                        <div className="col-xs-6">Počet spustení (týždeň):</div>
                                        <div className="col-xs-6 font-bold">
                                            {this.state.getArtikelByCiarovyKod.pocetTyden.toLocaleString("sk-SK", {
                                                maximumFractionDigits: 0
                                            })}
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-xs-6">Priemerná doba trvania (týždeň):</div>
                                        <div className="col-xs-6 font-bold">
                                            {this.state.getArtikelByCiarovyKod.trvaniPrumerTyden.toLocaleString("sk-SK", {
                                                style: "unit",
                                                unit: "millisecond",
                                                maximumFractionDigits: 0
                                            })}
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-xs-6">Maximálna doba trvania (týždeň):</div>
                                        <div className="col-xs-6 font-bold">
                                            {this.state.getArtikelByCiarovyKod.trvaniMaximumTyden.toLocaleString("sk-SK", {
                                                style: "unit",
                                                unit: "millisecond",
                                                maximumFractionDigits: 0
                                            })}
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-xs-6">Počet chyb (týždeň):</div>
                                        <div className="col-xs-6 font-bold">
                                            {this.state.getArtikelByCiarovyKod.chybyTyden ? (
                                                <span className="color-red">
                                                    {this.state.getArtikelByCiarovyKod.chybyTyden.toLocaleString("sk-SK", {
                                                        maximumFractionDigits: 0
                                                    })}
                                                </span>
                                            ) : (
                                                <span className="color-green">
                                                    {this.state.getArtikelByCiarovyKod.chybyTyden.toLocaleString("sk-SK", {
                                                        maximumFractionDigits: 0
                                                    })}
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                </React.Fragment>
                            )}
                        </fieldset>
                        <fieldset className="tools-button-group m-t-sm" id="ToolsPrijemBalikaUlozitTrvaniPanel">
                            <legend>
                                <Localization messageKey={"ToolsPage.Výkon rutiny"} defaultMessage={"Výkon rutiny"} /> - PrijemBalikaController.UlozitBalik:
                            </legend>
                            {this.state.loadingPrijemBalikaUlozit || !this.state.prijemBalikaUlozit ? (
                                <LoadingPanel />
                            ) : (
                                <React.Fragment>
                                    <div className="row">
                                        <div className="col-xs-6">Počet spustení (dnes):</div>
                                        <div className="col-xs-6 font-bold">
                                            {this.state.prijemBalikaUlozit.pocetDnes.toLocaleString("sk-SK", {
                                                maximumFractionDigits: 0
                                            })}
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-xs-6">Priemerná doba trvania (dnes):</div>
                                        <div className="col-xs-6 font-bold">
                                            {this.state.prijemBalikaUlozit.trvaniPrumerDnes.toLocaleString("sk-SK", {
                                                style: "unit",
                                                unit: "millisecond",
                                                maximumFractionDigits: 0
                                            })}
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-xs-6">Maximálna doba trvania (dnes):</div>
                                        <div className="col-xs-6 font-bold">
                                            {this.state.prijemBalikaUlozit.trvaniMaximumDnes.toLocaleString("sk-SK", {
                                                style: "unit",
                                                unit: "millisecond",
                                                maximumFractionDigits: 0
                                            })}
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-xs-6">Počet chyb (dnes):</div>
                                        <div className="col-xs-6 font-bold">
                                            {this.state.prijemBalikaUlozit.chybyDnes ? (
                                                <span className="color-red">
                                                    {this.state.prijemBalikaUlozit.chybyDnes.toLocaleString("sk-SK", {
                                                        maximumFractionDigits: 0
                                                    })}
                                                </span>
                                            ) : (
                                                <span className="color-green">
                                                    {this.state.prijemBalikaUlozit.chybyDnes.toLocaleString("sk-SK", {
                                                        maximumFractionDigits: 0
                                                    })}
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                    <div className="row m-t-sm">
                                        <div className="col-xs-6">Počet spustení (týždeň):</div>
                                        <div className="col-xs-6 font-bold">
                                            {this.state.prijemBalikaUlozit.pocetTyden.toLocaleString("sk-SK", {
                                                maximumFractionDigits: 0
                                            })}
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-xs-6">Priemerná doba trvania (týždeň):</div>
                                        <div className="col-xs-6 font-bold">
                                            {this.state.prijemBalikaUlozit.trvaniPrumerTyden.toLocaleString("sk-SK", {
                                                style: "unit",
                                                unit: "millisecond",
                                                maximumFractionDigits: 0
                                            })}
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-xs-6">Maximálna doba trvania (týždeň):</div>
                                        <div className="col-xs-6 font-bold">
                                            {this.state.prijemBalikaUlozit.trvaniMaximumTyden.toLocaleString("sk-SK", {
                                                style: "unit",
                                                unit: "millisecond",
                                                maximumFractionDigits: 0
                                            })}
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-xs-6">Počet chyb (týždeň):</div>
                                        <div className="col-xs-6 font-bold">
                                            {this.state.prijemBalikaUlozit.chybyTyden ? (
                                                <span className="color-red">
                                                    {this.state.prijemBalikaUlozit.chybyTyden.toLocaleString("sk-SK", {
                                                        maximumFractionDigits: 0
                                                    })}
                                                </span>
                                            ) : (
                                                <span className="color-green">
                                                    {this.state.prijemBalikaUlozit.chybyTyden.toLocaleString("sk-SK", {
                                                        maximumFractionDigits: 0
                                                    })}
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                </React.Fragment>
                            )}
                        </fieldset>
                        <fieldset className="tools-button-group m-t-sm" id="ToolsPrijemBalikaPridatKusTrvaniPanel">
                            <legend>
                                <Localization messageKey={"ToolsPage.Výkon rutiny"} defaultMessage={"Výkon rutiny"} /> - PrijemBalikaController.PridatKus:
                            </legend>
                            {this.state.loadingPrijemBalikaPridatKus || !this.state.prijemBalikaPridatKus ? (
                                <LoadingPanel />
                            ) : (
                                <React.Fragment>
                                    <div className="row">
                                        <div className="col-xs-6">Počet spustení (dnes):</div>
                                        <div className="col-xs-6 font-bold">
                                            {this.state.prijemBalikaPridatKus.pocetDnes.toLocaleString("sk-SK", {
                                                maximumFractionDigits: 0
                                            })}
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-xs-6">Priemerná doba trvania (dnes):</div>
                                        <div className="col-xs-6 font-bold">
                                            {this.state.prijemBalikaPridatKus.trvaniPrumerDnes.toLocaleString("sk-SK", {
                                                style: "unit",
                                                unit: "millisecond",
                                                maximumFractionDigits: 0
                                            })}
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-xs-6">Maximálna doba trvania (dnes):</div>
                                        <div className="col-xs-6 font-bold">
                                            {this.state.prijemBalikaPridatKus.trvaniMaximumDnes.toLocaleString("sk-SK", {
                                                style: "unit",
                                                unit: "millisecond",
                                                maximumFractionDigits: 0
                                            })}
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-xs-6">Počet chyb (dnes):</div>
                                        <div className="col-xs-6 font-bold">
                                            {this.state.prijemBalikaPridatKus.chybyDnes ? (
                                                <span className="color-red">
                                                    {this.state.prijemBalikaPridatKus.chybyDnes.toLocaleString("sk-SK", {
                                                        maximumFractionDigits: 0
                                                    })}
                                                </span>
                                            ) : (
                                                <span className="color-green">
                                                    {this.state.prijemBalikaPridatKus.chybyDnes.toLocaleString("sk-SK", {
                                                        maximumFractionDigits: 0
                                                    })}
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                    <div className="row m-t-sm">
                                        <div className="col-xs-6">Počet spustení (týždeň):</div>
                                        <div className="col-xs-6 font-bold">
                                            {this.state.prijemBalikaPridatKus.pocetTyden.toLocaleString("sk-SK", {
                                                maximumFractionDigits: 0
                                            })}
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-xs-6">Priemerná doba trvania (týždeň):</div>
                                        <div className="col-xs-6 font-bold">
                                            {this.state.prijemBalikaPridatKus.trvaniPrumerTyden.toLocaleString("sk-SK", {
                                                style: "unit",
                                                unit: "millisecond",
                                                maximumFractionDigits: 0
                                            })}
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-xs-6">Maximálna doba trvania (týždeň):</div>
                                        <div className="col-xs-6 font-bold">
                                            {this.state.prijemBalikaPridatKus.trvaniMaximumTyden.toLocaleString("sk-SK", {
                                                style: "unit",
                                                unit: "millisecond",
                                                maximumFractionDigits: 0
                                            })}
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-xs-6">Počet chyb (týždeň):</div>
                                        <div className="col-xs-6 font-bold">
                                            {this.state.prijemBalikaPridatKus.chybyTyden ? (
                                                <span className="color-red">
                                                    {this.state.prijemBalikaPridatKus.chybyTyden.toLocaleString("sk-SK", {
                                                        maximumFractionDigits: 0
                                                    })}
                                                </span>
                                            ) : (
                                                <span className="color-green">
                                                    {this.state.prijemBalikaPridatKus.chybyTyden.toLocaleString("sk-SK", {
                                                        maximumFractionDigits: 0
                                                    })}
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                </React.Fragment>
                            )}
                        </fieldset>
                    </div>
                </div>
                <DialogWindow dialog={this.state.dialog} />
            </div>
        );

        return <div className="wrapper wrapper-content">{contents}</div>;
    }
}

export default withRouter(Tools);



// WEBPACK FOOTER //
// ./src/components/views/Tools.js